import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Translation } from 'projects/qcloud-models/translation/translation.model';
import { CategoryTranslation } from 'projects/qcloud-models/translation/category-translation.model';

@Injectable({
    providedIn: 'root'
})
export class TranslationService {

    appBase: string;
    locationId: number;
    systemId: number;

    setAppBase(appConfig: any) {
        this.appBase = appConfig.appBase;
        this.locationId = appConfig.locationId;
        this.systemId = appConfig.systemId;
    }

    constructor(private http: HttpClient) { }

    getTranslations(): Observable<Translation[]> {
        return this.http.get<Translation[]>(
            `${this.appBase}api/${this.systemId}/${this.locationId}/translation`);
    }

    getCategoryTranslation(): Observable<CategoryTranslation[]> {
        return this.http.get<CategoryTranslation[]>(
            `${this.appBase}api/${this.systemId}/${this.locationId}/translation/category`);
    }

}